import React, { useSyncExternalStore } from 'react';

// Only viewport consumers subscribe. Moving the canvas must not rerender its plots.
export const createCanvasViewportStore = (initialViewport) => {
  let viewport = initialViewport;
  const listeners = new Set();
  let pendingFrame = null;
  return {
    getSnapshot: () => viewport,
    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
        if (!listeners.size && pendingFrame !== null) {
          cancelAnimationFrame(pendingFrame);
          pendingFrame = null;
        }
      };
    },
    set: (next) => {
      if (viewport.x === next.x && viewport.y === next.y && viewport.zoom === next.zoom) return;
      viewport = next;
      // The canvas transform updates immediately. Batch the menu, minimap,
      // and markup subscribers so pointer bursts render them once per frame.
      if (pendingFrame === null && listeners.size) {
        pendingFrame = requestAnimationFrame(() => {
          pendingFrame = null;
          listeners.forEach(listener => listener());
        });
      }
    },
  };
};

export default function CanvasViewportBinding({ store, children, propName = 'viewport', geometry, ...props }) {
  const viewport = useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
  const value = geometry ? {
    x: -viewport.x / viewport.zoom, y: -viewport.y / viewport.zoom,
    width: geometry.width / viewport.zoom, height: geometry.height / viewport.zoom,
  } : viewport;
  return React.cloneElement(children, { ...props, [propName]: value });
}
